<template>
  <div class="flex flex-wrap w-full gap-4 service-cards">
    <ServiceCard v-for="(card, index) in serviceCards" :key="index" :background-color="backgroundColor" :card="card" />
  </div>
</template>

<script setup lang="ts">
type ServiceCards = {
  metadata: any;
  sys: any;
  fields: {
    backgroundColor: string;
    serviceCards: any[];
    title: string;
  };
};

type Props = {
  content: ServiceCards;
};

const props = defineProps<Props>();

const serviceCards = computed(() => {
  return props.content.fields.serviceCards;
});

const backgroundColor = computed(() => {
  return props.content.fields.backgroundColor;
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'ServiceCards',
});
</script>

<style scoped lang="scss">
.service-cards {
  // On XL screens: When we have an even amount of cards, we want them to take up half of the space each on
  // this overrides the behavior of the 1/3 basis set on the card
  &:has(> :nth-child(even):last-child) div {
    @apply xl:basis-[calc(50%-1rem)];
  }

  // On XL screens: When we have exactly 5 cards, we want the last 2 to take grow to take up the remaining space on their row
  &:has(> :nth-child(5):last-child) > div:nth-last-of-type(-n + 2) {
    @apply xl:flex-[2];
  }
}
</style>
